<template>
  <div class="dialog-container dialog-light">
    <div class="chart-of-accounts-dialog drag-drop-grid">
      <div class="dialog-header">
        <ax-dialog-header text="Chart of Accounts" :type="'chart-of-accounts'" class="pt-0"></ax-dialog-header>
      </div>
      <div class="dialog-body pb-0">
        <div class="chart-of-accounts-form">
          <!-- sub header -->
          <div class="row">
            <div class="col-12 text-center">
              <p v-if="signUp" class="m-0">Below is a list of common Chart of Accounts used in your selected industry. Feel free to remove, add or reorder the list below. These can be edited later if needed.</p>
              <p v-if="!signUp" class="m-0">Below is your Chart of Accounts. Feel free to adjust, add, or reorder the accounts as needed - you can always edit them later</p>
            </div>
          </div>

          <div class="mt-5 mb-0">
            <div class="card bg-white rounded-1">
              <div class="card-body">
                <div class="accounts-table">
                  <!-- label column -->
                  <div class="row header-row">
                    <div :class="{'col-8': xeroConnected, 'col-7': !xeroConnected}">
                      <div class="row">
                        <div class="col-7">
                          <div class="row">
                            <div class="arrow-column"></div>
                            <div class="flex-1">
                              <label class="font-weight-bold">Name</label>
                            </div>
                          </div>
                        </div>
                        <div class="col-5">
                          <label class="font-weight-bold">Type</label>
                        </div>
                      </div>
                    </div>
                    <div :class="{'col-4': xeroConnected, 'col-5': !xeroConnected}">
                      <div class="row">
                        <div class="text-center" :class="{'col-6 text-center': xeroConnected || signUp, 'col-4 text-center': !xeroConnected}">
                          <label class="font-weight-bold">Excludes GST</label>
                        </div>
                        <div v-if="!signUp" :class="{'col-6 text-center': xeroConnected, 'col-4 text-center': !xeroConnected}">
                          <label class="font-weight-bold">Visibility</label>
                        </div>
                        <div :class="{'col-6 text-center': signUp, 'col-4 text-center': !xeroConnected}" v-if="!xeroConnected">
                          <label class="font-weight-bold">Remove</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- coa row -->
                  <div class="row align-items-center data-row" v-for="account in accounts.filter(x => x.deleted === false)" :key="account.expenseAccountID">
                    <div :class="{'col-8': xeroConnected, 'col-7': !xeroConnected}">
                      <div class="row">
                        <div class="col-7">
                          <div class="row">
                            <div class="arrow-column">
                                <div
                                  @click="moveUp(account.sortOrder)"
                                  class="mb-2 cursor-pointer"
                                  :class="(account.sortOrder != minSortOrder)?'':'pe-none'"
                                  tab="-1" aria-disabled="true">
                                  <i :class="(account.sortOrder != minSortOrder)?'':'opacity-25'" class="icon-arrow-up-1"></i>
                                </div>
                                <div
                                  @click="moveDown(account.sortOrder)"
                                  class="cursor-pointer"
                                  :class="(account.sortOrder != maxSortOrder) ? '' : 'pe-none'"
                                  tab="-1" aria-disabled="true">
                                  <i :class="(account.sortOrder != maxSortOrder) ? '' : 'opacity-25'" class="icon-arrow-down-1"></i>
                                </div>
                            </div>
                            <div class="flex-1">
                              <k-input
                                ref="nameInput"
                                type="text"
                                class="text-input grey-input"
                                :class="(!account.hidden)?'':'opacity-25'"
                                :disabled="account.hidden || xeroConnected"
                                v-model="account.description"
                                @change="nameChangeHandler(account.expenseAccountID)" />
                            </div>
                          </div>
                        </div>
                        <div class="col-5">
                          <k-dropdown-list
                            ref="typeList"
                            class="grey-input dropdown-no-label"
                            :label="' '"
                            :class="(!account.hidden)?'':'opacity-25'"
                            :data-items="types"
                            :text-field="'description'"
                            :data-item-key="'expenseAccountTypeID'"
                            :value-primitive="true"
                            v-model="account.expenseAccountType"
                            @change="typeOnChange(account, $event)" />
                        </div>
                      </div>
                    </div>
                    <div :class="{'col-4': xeroConnected, 'col-5': !xeroConnected}">
                      <div class="row align-items-center">
                        <div class="text-center" :class="{'col-6 text-center': xeroConnected || signUp, 'col-4 text-center': !xeroConnected}">
                          <k-checkbox
                            class="grey-input"
                            :disabled="account.hidden || xeroConnected || account.expenseAccountType.expenseAccountTypeID != 3"
                            :class="(!account.hidden)?'':'opacity-25'"
                            :checked="!account.gstInclusive"
                            @change="excludingGST(account, $event)"
                            size="large" />
                        </div>
                        <div v-if="!signUp" :class="{'col-6 text-center': xeroConnected, 'col-4 text-center': !xeroConnected}" v-b-tooltip.hover :title="(account.ableToHide) ? '':'Cannot hide, amount needs to be $0'">
                          <div
                            :id="'icon-visibility:' + account.expenseAccountID"
                            class="cursor-pointer"
                            @click="changeAccountVisibility(account)"
                            :class="cssClassForVisibleIcon(account)">
                            <i
                              class="icon-visibility text-primary"
                              ></i>
                          </div>
                        </div>
                        <div class="col-4 text-center" :class="{'col-6 text-center': signUp, 'col-4 text-center': !xeroConnected}"  v-if="!xeroConnected">
                          <div
                            :id="'icon-bin:' + account.expenseAccountID"
                            class="cursor-pointer"
                            @click.stop="showConfirmation(account.expenseAccountID, account.ableToDelete && account.expenseAccountType.expenseAccountTypeID == 3)"
                            :class="cssClassForDeleteIcon(account)">
                            <i class="icon-bin text-secondary"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- add new btt -->
                  <div class="row mt-3">
                    <div class="col">
                      <k-button class="btn btn-primary save mb-2 ms-2" type="button" v-if="!xeroConnected" @click="addNew">Add New</k-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <div class="row justify-content-center pt-5">
          <div class="col-12 col-lg-5 text-center">
            <k-button
              class="btn btn-lg btn-secondary w-100 save mb-2"
              type="button"
              @click="submit()"
            >Save</k-button>
            <k-button
              class="btn btn-lg btn-outline-primary w-100"
              type="button"
              @click="cancel()"
            >Cancel</k-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BusinessService from "../../services/business-service";
import Popup from "../../components/Popup.vue";
import store from "../../store";
import { useToast } from "vue-toastification";
const toast = useToast();

const ExpenseAccountTypes = {
  Expense: "Expense",
  Workcover: "Workcover"
};

export default {
  components: {
    "ax-popup": Popup
  },
  props: {
    signUp: Boolean,
    accounts: Array
  },
  data() {
    return {
      xeroConnected: false,
      invalidName: false,
      invalidType: false,
      types: [],
      selectedId: 0,
      modalContent: {
        title: "Chart of Accounts",
        description: "",
        closeBttText: "Ok",
        hideConfirmBtt: true
      },
      deleteChartOfAccountContent: {
        title: "Please Confirm",
        description: "Are you sure you want to delete this item?",
        closeBttText: "No",
        confirmBttText: "Yes"
      }
    }
  },
  computed: {
    anyInvalid: function() {
      return this.invalidName || this.invalidType;
    },
    isLoading() {
      return store.getters.isLoading;
    },
    isWorkcoverAccount(account) {
      return account.expenseAccountType.description === ExpenseAccountTypes.Workcover;
    },
    minSortOrder() {
      return Math.min(...this.accounts.filter(x => x.deleted === false).map(x => x.sortOrder));
    },
    maxSortOrder() {
      return Math.max(...this.accounts.filter(x => x.deleted === false).map(x => x.sortOrder));
    }
  },
  watch: {
    isLoading: async function() {
      this.reloadTriggerPointerEvent();
    }
  },
  async mounted() {
    await this.getExpenseAccountTypes();
    if (store.getters.isSubscriptionLocked) {
      return;
    }
    if (store.getters.businessID) {
      await this.getConnectedAccounts();
    }
    this.reloadTriggerPointerEvent();
  },
  methods: {
    nameChangeHandler(expenseAccountID) {
      var account = this.accounts.find(account => account.expenseAccountID === expenseAccountID);
      account.description = account.description.trim();
    },
    async getConnectedAccounts() {
      await BusinessService.getConnectedAccounts()
      .then((response) => {
        if (response && response.connectedAccount) {
          this.xeroConnected = true;
        } else {
          this.xeroConnected = false;
        }
      }).catch(this.showAlert);
    },
    async getExpenseAccountTypes() {
      const d = await BusinessService.getExpenseAccountTypes();
      this.types = d.types;
    },
    async submit() {
      try {
        var valid = await this.validate();
        if (valid) {
          if (!this.signUp) {
            const response = await BusinessService.saveExpenseAccounts(this.accounts);
            //code 204 for avoid error from Firefox
            if (response.status === 200 || response.status === 204) {
              toast.clear();
              toast.success("Success!");
              this.$emit("closePopup");
              if (location.href.includes("cashSummary") || location.href.includes("profitLoss")) {
                setTimeout(() => {
                  location = location.href;
                }, 1000);
              }
            }
          }
          else {
            this.$emit("onSubmit");
          }
        }
      }
      catch {
        this.showAlert();
      }
    },
    validate() {
      var wagesCount = this.accounts.filter(account => account.expenseAccountType.expenseAccountTypeID === 1 && !account.deleted && !account.hidden).length;
      var superCount = this.accounts.filter(account => account.expenseAccountType.expenseAccountTypeID === 2 && !account.deleted && !account.hidden).length;
      var workcoverCount = this.accounts.filter(account => account.expenseAccountType.expenseAccountTypeID === 4 && !account.deleted && !account.hidden).length;
      var emptyDescriptionCount = this.accounts.filter(account => !account.description).length;
      var duplicateDescriptionCount = 0;
      var descriptionList = [];
      this.accounts.forEach(x => {
        if (descriptionList.includes(x.description)) {
          duplicateDescriptionCount++;
        } else {
          descriptionList.push(x.description);
        }
      });
      if (wagesCount === 0) {
        this.showSpecificAlert("Expense account with type 'Wages' is required (and must be visible).");
        return false;
      } else if (superCount === 0) {
        this.showSpecificAlert("Expense account with type 'Super' is required (and must be visible).");
        return false;
      } else if (wagesCount > 1 && !this.xeroConnected) {
        this.showSpecificAlert("Only one expense account with type 'Wages' is allowed.");
        return false;
      } else if (superCount > 1 && !this.xeroConnected) {
        this.showSpecificAlert("Only one expense account with type 'Super' is allowed.");
        return false;
      } else if (emptyDescriptionCount > 0) {
        this.showSpecificAlert("Please ensure all accounts have a name.");
        return false;
      } else if (duplicateDescriptionCount > 0) {
        this.showSpecificAlert("Please ensure you have no duplicate account names.");
        return false;
      } else if (workcoverCount > 1) {
        this.showSpecificAlert("Only one expense account with type 'Workcover' is allowed.");
        return false;
      }
      return true;
    },
    validateRemove(ID) {
      if (this.accounts.find(account => account.expenseAccountID === ID).ableToDelete) {
        return true;
      }
      return false;
    },
    cancel() {
      this.$emit("closePopup");
    },
    showAlert() {
      toast.clear();
      toast.error("Something went wrong! Please try again.");
    },
    showSpecificAlert(alert) {
      toast.clear();
      toast.error(alert);
    },
    addNew() {
      var newID = Math.max(...this.accounts.map(x => x.expenseAccountID)) + 1;
      const newOrder = Math.max(...this.accounts.map(e => e.sortOrder)) + 1;
      var newRow = {
        expenseAccountID: newID,
        description: "New Account",
        gstInclusive: true,
        expenseAccountType: {
          expenseAccountTypeID: 3,
          description: "Expense"
        },
        hidden: false,
        sortOrder: newOrder,
        deleted: false,
        new: true,
        ableToHide: true,
        ableToDelete: true
      };
      this.accounts.push(newRow);
    },
    showConfirmation(id, notDisabled) {
      this.selectedId = id;
      if (notDisabled) {
        this.removeAccount();
      }
    },
    removeAccount() {
      var account = this.accounts.find(account => account.expenseAccountID === this.selectedId);
      var accountIndex = this.accounts.indexOf(account);
      if (this.signUp) {
        if (accountIndex !== -1) {
          this.accounts.splice(accountIndex, 1);
        }
      } else {
        var valid = this.validateRemove(this.selectedId);
        if (valid) {
          if (account.new) {
            if (this.signUp) {
              this.accounts = this.accounts.filter(account => account.expenseAccountID !== this.selectedId);
            }
            else {
              this.$emit("updateAccounts", this.accounts.filter(account => account.expenseAccountID !== this.selectedId));
            }
          }
          else {
            this.accounts.find(account => account.expenseAccountID === this.selectedId).deleted = true;
          }
        }
      }
      this.setCorrectSortOrder();
    },
    changeAccountVisibility(accountDetails) {
      if (accountDetails.ableToHide) {
        this.accounts.find(account => account.expenseAccountID === accountDetails.expenseAccountID).hidden = !this.accounts.find(account => account.expenseAccountID === accountDetails.expenseAccountID).hidden;
      }
    },
    setCorrectSortOrder() {
      this.accounts.filter(x => x.deleted === false).forEach((acc, index) => {
        acc.sortOrder = index;
      });
    },
    moveUp(sortOrder) {
      const index = this.accounts.findIndex(e => e.sortOrder === sortOrder);
      if (index >= 0) {
        const el = this.accounts[index];
        this.accounts[index] = this.accounts[index - 1];
        this.accounts[index - 1] = el;
        this.setCorrectSortOrder();
      }
    },
    moveDown(sortOrder) {
      const index = this.accounts.findIndex(e => e.sortOrder === sortOrder);
      if (index >= 0) {
        const newIndex = index + 1;
        if (newIndex >= this.accounts.length) {
          var k = newIndex - this.accounts.length + 1;
          while (k--) {
              this.accounts.push(undefined);
          }
        }
        this.accounts.splice(newIndex, 0, this.accounts.splice(index, 1)[0]);
        this.setCorrectSortOrder();
      }
    },
    excludingGST(account, event) {
      this.accounts.find(x => x.expenseAccountID === account.expenseAccountID).gstInclusive = !event.value;
    },
    reloadTriggerPointerEvent() {
      document.querySelectorAll(".opacity-25").forEach(el => { el.style.pointerEvents = "none" });
    },
    cssClassForVisibleIcon(account) {
      if (account.ableToHide) {
        if (account.hidden) {
          return "opacity-25-visible";
        }
        return "";
      }
      else {
        return "opacity-25 visible";
      }
    },
    cssClassForDeleteIcon(account) {
      if (account.expenseAccountType.expenseAccountTypeID == 3 && (this.signUp || account.ableToDelete)) {
        return "";
      }
      return "opacity-25";
    },
    typeOnChange(account) {
      if (account.expenseAccountType.description === ExpenseAccountTypes.Workcover) {
        account.gstInclusive = true;
      }
    }
  }
}

</script>
